import { render } from "./WpeAuth.vue?vue&type=template&id=f6f27f18"
import script from "./WpeAuth.vue?vue&type=script&lang=js"
export * from "./WpeAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WpeAuth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6f27f18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6f27f18', __exports__)) {
    api.reload('f6f27f18', __exports__)
  }
  
  module.hot.accept("./WpeAuth.vue?vue&type=template&id=f6f27f18", () => {
    api.rerender('f6f27f18', render)
  })

}


export default __exports__